import { render } from "./MostProfitBets.vue?vue&type=template&id=6edafa48&scoped=true"
import script from "./MostProfitBets.vue?vue&type=script&lang=js"
export * from "./MostProfitBets.vue?vue&type=script&lang=js"

import "./MostProfitBets.vue?vue&type=style&index=0&id=6edafa48&scoped=true&lang=css"
/* custom blocks */
import block0 from "./MostProfitBets.vue?vue&type=custom&index=0&blockType=span"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6edafa48"]])

export default __exports__